export class GetDashboardConfiguration {
  static readonly type = '[Dashboard] Get Configuration';
  constructor() {}
}

export class GetUserProjects {
  static readonly type = '[Dashboard] Get Projects';
}

export class GetAllUsersProjects{
  static readonly type = '[Admin Dashboard] Get All Users Projects';
}
export class DeleteProject {
  static readonly type = '[Dashboard] Delete Project';
  constructor(public projectId: string) {}
}

export class CloneProject {
  static readonly type = '[Dashboard] Clone Project';
  constructor(public projectId: string, public isAdmin: boolean, public originalCreatedDate: string | null) {}
}

export class FetchEmployeesList {
  static readonly type = '[Dashboard] Employees List';
  constructor(public keyword: string) {}
}

export class ShareProject {
  static readonly type = '[Dashboard] SHare Project';
  constructor(public projectId: string, public payload: any ) {}
}